import React, { useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CameraIcon, ImagePlusIcon, XIcon } from 'lucide-react';
import { EstimatePhoto, MAX_PHOTOS } from './useEstimateForm';
type PhotoUploadProps = {
  photos: EstimatePhoto[];
  error: string;
  onAdd: (files: FileList | null) => void;
  onRemove: (id: string) => void;
};
export function PhotoUpload({
  photos,
  error,
  onAdd,
  onRemove
}: PhotoUploadProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const full = photos.length >= MAX_PHOTOS;
  return <div data-id="element-132" data-mp="2t612eodctptv">
      <p className="mb-1.5 text-sm font-medium text-ink" data-id="element-133" data-mp="2t9xb5m2e9tmy">
        Photos of your yard <span className="font-normal text-ink-muted" data-id="element-134" data-mp="2y7gp0kv6k4ed">(optional, up to {MAX_PHOTOS})</span>
      </p>
      <input ref={inputRef} id="estimate-photos" type="file" accept="image/*" multiple className="sr-only" onChange={e => {
      onAdd(e.target.files);
      e.target.value = '';
    }} data-id="element-135" data-mp="335i6j1cyjvnq" />

      {photos.length === 0 ? <label htmlFor="estimate-photos" className="flex cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-stone-line bg-stone-soft/60 px-4 py-6 text-center transition-colors duration-150 hover:border-forest/40 hover:bg-stone-soft" data-id="element-136" data-mp="15zn8uhcf3kgi">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-forest shadow-sm" data-id="element-137" data-mp="s8ifty3k1qf5">
            <CameraIcon className="h-5 w-5" aria-hidden="true" data-id="element-138" data-mp="1oukc9qvjoxnc" />
          </span>
          <span className="text-sm font-semibold text-forest" data-id="element-139" data-mp="1jymurh8jpl8z">Add photos</span>
          <span className="text-xs text-ink-muted" data-id="element-140" data-mp="1fux8iyfcffr4">Helps us give you a more accurate price</span>
        </label> : <ul className="grid grid-cols-3 gap-2 sm:grid-cols-5" data-id="element-141" data-mp="1az9m2qs8x0pb">
          <AnimatePresence initial={false} data-id="element-142" data-mp="4i4jhvdxt5er">
            {photos.map(p => <motion.li key={p.id} layout initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.96
        }} transition={{
          duration: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative aspect-square overflow-hidden rounded-lg border border-stone-line" data-id="element-143" data-mp="3vmuxemyyppi9">
                <img src={p.url} alt={`Selected photo ${p.file.name}`} className="h-full w-full object-cover" data-id="element-144" data-mp="3s45jztzamodr" />
                <button type="button" onClick={() => onRemove(p.id)} aria-label={`Remove ${p.file.name}`} className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-ink/75 text-white transition-colors duration-150 hover:bg-brick" data-id="element-145" data-mp="3echbs1s60k22">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-146" data-mp="2veo5qqm8vu0g" />
                </button>
              </motion.li>)}
          </AnimatePresence>
          {!full && <li data-id="element-147" data-mp="2gshekjrxjlic">
              <button type="button" onClick={() => inputRef.current?.click()} className="flex aspect-square w-full flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed border-stone-line text-xs font-medium text-ink-muted transition-colors duration-150 hover:border-forest/40 hover:text-forest" data-id="element-148" data-mp="2grz9qyr7byyt">
                <ImagePlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-149" data-mp="2zrd3pgoxl9pb" />
                Add
              </button>
            </li>}
        </ul>}
      {error && <p className="mt-1.5 text-xs text-brick" data-id="element-150" data-mp="2us0begfajafc">{error}</p>}
    </div>;
}